/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ColumnMetadataDto } from '../models/column-metadata-dto';
import { DataSourceDto } from '../models/data-source-dto';
import { DataSourceListDto } from '../models/data-source-list-dto';
import { datasourcesDataSourceIdDelete } from '../fn/data-sources/datasources-data-source-id-delete';
import { DatasourcesDataSourceIdDelete$Params } from '../fn/data-sources/datasources-data-source-id-delete';
import { datasourcesDataSourceIdGet$Json } from '../fn/data-sources/datasources-data-source-id-get-json';
import { DatasourcesDataSourceIdGet$Json$Params } from '../fn/data-sources/datasources-data-source-id-get-json';
import { datasourcesDataSourceIdGet$Plain } from '../fn/data-sources/datasources-data-source-id-get-plain';
import { DatasourcesDataSourceIdGet$Plain$Params } from '../fn/data-sources/datasources-data-source-id-get-plain';
import { datasourcesDataSourceIdPut$Json } from '../fn/data-sources/datasources-data-source-id-put-json';
import { DatasourcesDataSourceIdPut$Json$Params } from '../fn/data-sources/datasources-data-source-id-put-json';
import { datasourcesDataSourceIdPut$Plain } from '../fn/data-sources/datasources-data-source-id-put-plain';
import { DatasourcesDataSourceIdPut$Plain$Params } from '../fn/data-sources/datasources-data-source-id-put-plain';
import { datasourcesDataSourceIdSyncMetadataPost } from '../fn/data-sources/datasources-data-source-id-sync-metadata-post';
import { DatasourcesDataSourceIdSyncMetadataPost$Params } from '../fn/data-sources/datasources-data-source-id-sync-metadata-post';
import { datasourcesDataSourceIdTablesGet$Json } from '../fn/data-sources/datasources-data-source-id-tables-get-json';
import { DatasourcesDataSourceIdTablesGet$Json$Params } from '../fn/data-sources/datasources-data-source-id-tables-get-json';
import { datasourcesDataSourceIdTablesGet$Plain } from '../fn/data-sources/datasources-data-source-id-tables-get-plain';
import { DatasourcesDataSourceIdTablesGet$Plain$Params } from '../fn/data-sources/datasources-data-source-id-tables-get-plain';
import { datasourcesDataSourceIdTestPost$Json } from '../fn/data-sources/datasources-data-source-id-test-post-json';
import { DatasourcesDataSourceIdTestPost$Json$Params } from '../fn/data-sources/datasources-data-source-id-test-post-json';
import { datasourcesDataSourceIdTestPost$Plain } from '../fn/data-sources/datasources-data-source-id-test-post-plain';
import { DatasourcesDataSourceIdTestPost$Plain$Params } from '../fn/data-sources/datasources-data-source-id-test-post-plain';
import { datasourcesGet$Json } from '../fn/data-sources/datasources-get-json';
import { DatasourcesGet$Json$Params } from '../fn/data-sources/datasources-get-json';
import { datasourcesGet$Plain } from '../fn/data-sources/datasources-get-plain';
import { DatasourcesGet$Plain$Params } from '../fn/data-sources/datasources-get-plain';
import { datasourcesPost$Json } from '../fn/data-sources/datasources-post-json';
import { DatasourcesPost$Json$Params } from '../fn/data-sources/datasources-post-json';
import { datasourcesPost$Plain } from '../fn/data-sources/datasources-post-plain';
import { DatasourcesPost$Plain$Params } from '../fn/data-sources/datasources-post-plain';
import { datasourcesTablesTableMetadataIdColumnsGet$Json } from '../fn/data-sources/datasources-tables-table-metadata-id-columns-get-json';
import { DatasourcesTablesTableMetadataIdColumnsGet$Json$Params } from '../fn/data-sources/datasources-tables-table-metadata-id-columns-get-json';
import { datasourcesTablesTableMetadataIdColumnsGet$Plain } from '../fn/data-sources/datasources-tables-table-metadata-id-columns-get-plain';
import { DatasourcesTablesTableMetadataIdColumnsGet$Plain$Params } from '../fn/data-sources/datasources-tables-table-metadata-id-columns-get-plain';
import { datasourcesTestPost$Json } from '../fn/data-sources/datasources-test-post-json';
import { DatasourcesTestPost$Json$Params } from '../fn/data-sources/datasources-test-post-json';
import { datasourcesTestPost$Plain } from '../fn/data-sources/datasources-test-post-plain';
import { DatasourcesTestPost$Plain$Params } from '../fn/data-sources/datasources-test-post-plain';
import { TableMetadataDto } from '../models/table-metadata-dto';
import { TestConnectionResultDto } from '../models/test-connection-result-dto';

@Injectable({ providedIn: 'root' })
export class DataSourcesApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `datasourcesGet()` */
  static readonly DatasourcesGetPath = '/datasources';

  /**
   * List data sources.
   *
   * Lists data sources, optionally filtered by search term.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesGet$Plain$Response(params?: DatasourcesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceListDto>>> {
    const obs = datasourcesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List data sources.
   *
   * Lists data sources, optionally filtered by search term.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesGet$Plain(params?: DatasourcesGet$Plain$Params, context?: HttpContext): Observable<Array<DataSourceListDto>> {
    const resp = this.datasourcesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DataSourceListDto>>): Array<DataSourceListDto> => r.body)
    );
  }

  /**
   * List data sources.
   *
   * Lists data sources, optionally filtered by search term.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesGet$Json$Response(params?: DatasourcesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DataSourceListDto>>> {
    const obs = datasourcesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List data sources.
   *
   * Lists data sources, optionally filtered by search term.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesGet$Json(params?: DatasourcesGet$Json$Params, context?: HttpContext): Observable<Array<DataSourceListDto>> {
    const resp = this.datasourcesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DataSourceListDto>>): Array<DataSourceListDto> => r.body)
    );
  }

  /** Path part for operation `datasourcesPost()` */
  static readonly DatasourcesPostPath = '/datasources';

  /**
   * Create data source.
   *
   * Creates a new data source and triggers metadata sync. Requires ManageDataSources + paid feature.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesPost$Plain$Response(params?: DatasourcesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create data source.
   *
   * Creates a new data source and triggers metadata sync. Requires ManageDataSources + paid feature.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesPost$Plain(params?: DatasourcesPost$Plain$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /**
   * Create data source.
   *
   * Creates a new data source and triggers metadata sync. Requires ManageDataSources + paid feature.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesPost$Json$Response(params?: DatasourcesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create data source.
   *
   * Creates a new data source and triggers metadata sync. Requires ManageDataSources + paid feature.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesPost$Json(params?: DatasourcesPost$Json$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdGet()` */
  static readonly DatasourcesDataSourceIdGetPath = '/datasources/{dataSourceId}';

  /**
   * Get data source.
   *
   * Gets data source configuration for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdGet$Plain$Response(params: DatasourcesDataSourceIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesDataSourceIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get data source.
   *
   * Gets data source configuration for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdGet$Plain(params: DatasourcesDataSourceIdGet$Plain$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesDataSourceIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /**
   * Get data source.
   *
   * Gets data source configuration for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdGet$Json$Response(params: DatasourcesDataSourceIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesDataSourceIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get data source.
   *
   * Gets data source configuration for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdGet$Json(params: DatasourcesDataSourceIdGet$Json$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesDataSourceIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdPut()` */
  static readonly DatasourcesDataSourceIdPutPath = '/datasources/{dataSourceId}';

  /**
   * Update data source.
   *
   * Updates connection info and flags. Requires ManageDataSources.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdPut$Plain$Response(params: DatasourcesDataSourceIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesDataSourceIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update data source.
   *
   * Updates connection info and flags. Requires ManageDataSources.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdPut$Plain(params: DatasourcesDataSourceIdPut$Plain$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesDataSourceIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /**
   * Update data source.
   *
   * Updates connection info and flags. Requires ManageDataSources.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdPut$Json$Response(params: DatasourcesDataSourceIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceDto>> {
    const obs = datasourcesDataSourceIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update data source.
   *
   * Updates connection info and flags. Requires ManageDataSources.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdPut$Json(params: DatasourcesDataSourceIdPut$Json$Params, context?: HttpContext): Observable<DataSourceDto> {
    const resp = this.datasourcesDataSourceIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DataSourceDto>): DataSourceDto => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdDelete()` */
  static readonly DatasourcesDataSourceIdDeletePath = '/datasources/{dataSourceId}';

  /**
   * Delete data source.
   *
   * Soft-deletes a data source. Requires ManageDataSources.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdDelete$Response(params: DatasourcesDataSourceIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = datasourcesDataSourceIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete data source.
   *
   * Soft-deletes a data source. Requires ManageDataSources.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesDataSourceIdDelete(params: DatasourcesDataSourceIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.datasourcesDataSourceIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `datasourcesTestPost()` */
  static readonly DatasourcesTestPostPath = '/datasources/test';

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesTestPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesTestPost$Plain$Response(params?: DatasourcesTestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
    const obs = datasourcesTestPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesTestPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesTestPost$Plain(params?: DatasourcesTestPost$Plain$Params, context?: HttpContext): Observable<TestConnectionResultDto> {
    const resp = this.datasourcesTestPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestConnectionResultDto>): TestConnectionResultDto => r.body)
    );
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesTestPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesTestPost$Json$Response(params?: DatasourcesTestPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
    const obs = datasourcesTestPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesTestPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  datasourcesTestPost$Json(params?: DatasourcesTestPost$Json$Params, context?: HttpContext): Observable<TestConnectionResultDto> {
    const resp = this.datasourcesTestPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestConnectionResultDto>): TestConnectionResultDto => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdTestPost()` */
  static readonly DatasourcesDataSourceIdTestPostPath = '/datasources/{dataSourceId}/test';

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdTestPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTestPost$Plain$Response(params: DatasourcesDataSourceIdTestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
    const obs = datasourcesDataSourceIdTestPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdTestPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTestPost$Plain(params: DatasourcesDataSourceIdTestPost$Plain$Params, context?: HttpContext): Observable<TestConnectionResultDto> {
    const resp = this.datasourcesDataSourceIdTestPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestConnectionResultDto>): TestConnectionResultDto => r.body)
    );
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdTestPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTestPost$Json$Response(params: DatasourcesDataSourceIdTestPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TestConnectionResultDto>> {
    const obs = datasourcesDataSourceIdTestPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Test data source connection.
   *
   * Executes a lightweight connectivity check for the data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdTestPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTestPost$Json(params: DatasourcesDataSourceIdTestPost$Json$Params, context?: HttpContext): Observable<TestConnectionResultDto> {
    const resp = this.datasourcesDataSourceIdTestPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestConnectionResultDto>): TestConnectionResultDto => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdSyncMetadataPost()` */
  static readonly DatasourcesDataSourceIdSyncMetadataPostPath = '/datasources/{dataSourceId}/sync-metadata';

  /**
   * Sync data source metadata.
   *
   * Reads schema/spreadsheet metadata and updates internal TableMetadata/ColumnMetadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdSyncMetadataPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdSyncMetadataPost$Response(params: DatasourcesDataSourceIdSyncMetadataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = datasourcesDataSourceIdSyncMetadataPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sync data source metadata.
   *
   * Reads schema/spreadsheet metadata and updates internal TableMetadata/ColumnMetadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdSyncMetadataPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdSyncMetadataPost(params: DatasourcesDataSourceIdSyncMetadataPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.datasourcesDataSourceIdSyncMetadataPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `datasourcesDataSourceIdTablesGet()` */
  static readonly DatasourcesDataSourceIdTablesGetPath = '/datasources/{dataSourceId}/tables';

  /**
   * List tables.
   *
   * Returns all tables/views discovered for a data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdTablesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTablesGet$Plain$Response(params: DatasourcesDataSourceIdTablesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TableMetadataDto>>> {
    const obs = datasourcesDataSourceIdTablesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List tables.
   *
   * Returns all tables/views discovered for a data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdTablesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTablesGet$Plain(params: DatasourcesDataSourceIdTablesGet$Plain$Params, context?: HttpContext): Observable<Array<TableMetadataDto>> {
    const resp = this.datasourcesDataSourceIdTablesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TableMetadataDto>>): Array<TableMetadataDto> => r.body)
    );
  }

  /**
   * List tables.
   *
   * Returns all tables/views discovered for a data source.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesDataSourceIdTablesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTablesGet$Json$Response(params: DatasourcesDataSourceIdTablesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TableMetadataDto>>> {
    const obs = datasourcesDataSourceIdTablesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List tables.
   *
   * Returns all tables/views discovered for a data source.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesDataSourceIdTablesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesDataSourceIdTablesGet$Json(params: DatasourcesDataSourceIdTablesGet$Json$Params, context?: HttpContext): Observable<Array<TableMetadataDto>> {
    const resp = this.datasourcesDataSourceIdTablesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<TableMetadataDto>>): Array<TableMetadataDto> => r.body)
    );
  }

  /** Path part for operation `datasourcesTablesTableMetadataIdColumnsGet()` */
  static readonly DatasourcesTablesTableMetadataIdColumnsGetPath = '/datasources/tables/{tableMetadataId}/columns';

  /**
   * List columns for table.
   *
   * Returns all columns for a specific table.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesTablesTableMetadataIdColumnsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesTablesTableMetadataIdColumnsGet$Plain$Response(params: DatasourcesTablesTableMetadataIdColumnsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ColumnMetadataDto>>> {
    const obs = datasourcesTablesTableMetadataIdColumnsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List columns for table.
   *
   * Returns all columns for a specific table.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesTablesTableMetadataIdColumnsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesTablesTableMetadataIdColumnsGet$Plain(params: DatasourcesTablesTableMetadataIdColumnsGet$Plain$Params, context?: HttpContext): Observable<Array<ColumnMetadataDto>> {
    const resp = this.datasourcesTablesTableMetadataIdColumnsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ColumnMetadataDto>>): Array<ColumnMetadataDto> => r.body)
    );
  }

  /**
   * List columns for table.
   *
   * Returns all columns for a specific table.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `datasourcesTablesTableMetadataIdColumnsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesTablesTableMetadataIdColumnsGet$Json$Response(params: DatasourcesTablesTableMetadataIdColumnsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ColumnMetadataDto>>> {
    const obs = datasourcesTablesTableMetadataIdColumnsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List columns for table.
   *
   * Returns all columns for a specific table.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `datasourcesTablesTableMetadataIdColumnsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  datasourcesTablesTableMetadataIdColumnsGet$Json(params: DatasourcesTablesTableMetadataIdColumnsGet$Json$Params, context?: HttpContext): Observable<Array<ColumnMetadataDto>> {
    const resp = this.datasourcesTablesTableMetadataIdColumnsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ColumnMetadataDto>>): Array<ColumnMetadataDto> => r.body)
    );
  }

}
